import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { DEFAULT_ADMIN_NAMESPACE } from '@cli-constants/scaffolding.js'
import { deriveMigrationsDir } from '@next-adapter/config/namespace/derive-migrations-dir.js'
import { deriveNamespacePaths } from '@next-adapter/config/namespace/derive-namespace-paths.js'

export function getDefaultConfig(
  srcDir: boolean,
  nextMajorVersion = 16
): ResolvedBetterstartConfig {
  const namespace = DEFAULT_ADMIN_NAMESPACE
  const paths = deriveNamespacePaths(namespace, srcDir)

  return {
    framework: 'next',
    frameworkConfig: {
      next: {
        namespace,
        srcDir,
        version: nextMajorVersion,
        paths
      }
    },
    srcDir,
    nextMajorVersion,
    paths,
    database: {
      provider: 'postgres',
      migrationsDir: deriveMigrationsDir(namespace)
    },
    presets: {
      installed: []
    },
    integrations: {
      installed: []
    },
    email: {
      provider: 'none'
    },
    storage: {
      provider: 'local'
    },
    linter: 'oxlint',
    generated: {
      entities: [],
      singles: [],
      forms: []
    }
  }
}
